import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "flex items-center p-4 space-x-2 text-black border rounded bg-alert-warning border-alert-warning" }
const _hoisted_3 = { class: "mt-2 border border-gray-400 rounded" }
const _hoisted_4 = { class: "px-4 py-2 bg-gray-100 border-b border-gray-400" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "capitalize" }
const _hoisted_7 = { class: "capitalize" }
const _hoisted_8 = {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 0,
  class: "mb-2 italic"
}
const _hoisted_11 = { class: "hidden w-full table-auto md:table" }
const _hoisted_12 = { class: "font-bold text-left border-b-2 border-black divide-x-2 divide-gray-400" }
const _hoisted_13 = {
  scope: "col",
  class: "w-1/4 px-2 py-2 capitalize"
}
const _hoisted_14 = {
  scope: "col",
  class: "w-1/4 px-2 py-2"
}
const _hoisted_15 = {
  scope: "col",
  class: "w-1/4 px-2 py-2"
}
const _hoisted_16 = {
  scope: "col",
  class: "w-1/4 px-2 py-2 capitalize"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "w-1/4 px-2 py-2"
}, null, -1)
const _hoisted_18 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_19 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_20 = { class: "w-64 px-2 py-3 capitalize" }
const _hoisted_21 = { class: "w-64 px-2 py-3" }
const _hoisted_22 = { class: "block md:hidden" }
const _hoisted_23 = { class: "w-full px-2 py-3 capitalize" }
const _hoisted_24 = { class: "mx-1 font-bold" }
const _hoisted_25 = { class: "w-full px-2 py-3 capitalize" }
const _hoisted_26 = { class: "mx-1 font-bold" }
const _hoisted_27 = { class: "w-full px-2 py-3 capitalize" }
const _hoisted_28 = { class: "mx-1 font-bold" }
const _hoisted_29 = { class: "w-full px-2 py-3 capitalize" }
const _hoisted_30 = { class: "mx-1 font-bold" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "w-full px-2 py-3 capitalize" }, null, -1)
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "flex" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "inset-y-0 left-0 flex items-center px-4 bg-gray-200 border-l border-gray-400 rounded-l border-y" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "" }, "https://")
], -1)
const _hoisted_35 = { class: "space-y-2.5" }
const _hoisted_36 = ["placeholder"]
const _hoisted_37 = ["placeholder"]
const _hoisted_38 = ["placeholder"]
const _hoisted_39 = ["placeholder"]
const _hoisted_40 = {
  class: "capitalize",
  value: "",
  selected: "",
  disabled: ""
}
const _hoisted_41 = ["value"]
const _hoisted_42 = { class: "flex flex-wrap space-y-2" }
const _hoisted_43 = ["placeholder"]
const _hoisted_44 = { class: "text-sm text-gray-900" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("a", { href: "https://goo.gl/maps/8joDRwk36ENmxito9" }, "https://goo.gl/maps/8joDRwk36ENmxito9", -1)
const _hoisted_46 = ["value"]
const _hoisted_47 = ["value"]
const _hoisted_48 = { class: "" }
const _hoisted_49 = {
  key: 1,
  class: "flex items-center space-x-2"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-700" }, "(Trainer Pricing)", -1)
const _hoisted_51 = { class: "flex items-center" }
const _hoisted_52 = { class: "capitalize" }
const _hoisted_53 = ["currency"]
const _hoisted_54 = { class: "block" }
const _hoisted_55 = {
  class: "lowercase",
  value: "",
  selected: "",
  disabled: ""
}
const _hoisted_56 = ["value"]
const _hoisted_57 = { class: "mt-4" }
const _hoisted_58 = { class: "mt-4" }
const _hoisted_59 = { class: "flex space-x-4" }
const _hoisted_60 = { class: "block space-x-2" }
const _hoisted_61 = { class: "inline-block pl-[0.15rem]" }
const _hoisted_62 = { class: "block space-x-2" }
const _hoisted_63 = { class: "inline-block pl-[0.15rem]" }
const _hoisted_64 = { class: "block space-x-2" }
const _hoisted_65 = { class: "inline-block pl-[0.15rem]" }
const _hoisted_66 = { class: "flex" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "inset-y-0 left-0 flex items-center px-4 bg-gray-200 border-l border-gray-400 rounded-l border-y" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "" }, "https://")
], -1)
const _hoisted_68 = ["placeholder"]
const _hoisted_69 = { class: "px-4 py-4 bg-gray-100 border-t border-gray-400" }
const _hoisted_70 = { class: "flex flex-wrap gap-4 py-6" }

import { computed, ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import { storeToRefs } from "pinia";

import AvailableCountriesModal from "@/components/modals/AvailableCountriesModal.vue";
import AddPresentersInput from "@/components/events/AddPresentersInput.vue";
import DefaultButton from "@/components/DefaultButton.vue";
import PriceDisplay from "@/components/PriceDisplay.vue";
import ListRowItem from "@/components/ListRowItem.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import TagSelector from "@/components/TagSelector.vue";
import RoleGuard from "@/components/RoleGuard.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";

import api from "@/api/api";
import { formatDate, getFutureTimezone } from "@/utils/dates";
import { Event, Template, User } from "@/types";
import { useGlobalStore, useUserStore } from "@/store";

import { deserializeSlug } from "@/utils/slugify";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditEventPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const globalStore = useGlobalStore();
const { user, timezone, short_timezone, timezone_offset, userIsAdmin } = storeToRefs(useUserStore());
const { t: $t } = useI18n();

const isAvailableCountriesModalOpen = ref(false);
const isLoading = ref(true);
const isSaving = ref(false);
const isReviewSaving = ref(false);
const isDeleteConfirmationOpen = ref(false);
const canDelete = ref(false);

const asyncEventDelivery = ["e-learning"];
const syncEventDelivery = ["live-webinar", "in-person"];

const selectedTemplate = ref({} as Template);
const selectedTemplatePricing = ref({} as any);
const selectedTags = ref([] as number[]);
const languages = ref([] as string[]);
const event = ref({} as Event);
const users = ref([] as User[]);
const presenters = ref([] as string[]);
const countries = ref([] as string[]);
const dates = ref([
  {
    end_time: "",
    event_date: "",
    start_time: "",
    created_at: "",
    updated_at: "",
    timezone: timezone.value,
    short_timezone: short_timezone.value,
    timezone_offset: timezone_offset.value,
  },
] as { [key: string]: any }[]);
const templates = ref([] as Template[]);

const datepicker = ref(null);
const publish_at_datepicker = ref(null);
const register_by_datepicker = ref(null);

const isAsyncEvent = computed(() => {
  if (selectedTemplate.value.level === "Specialist (Level 3)") {
    return true;
  }

  if (asyncEventDelivery.includes(selectedTemplate.value.delivery)) {
    return true;
  }

  return false;
});

function utcToLocalNoon(dateStr: string): string {
  return dateStr.split("T")[0] + "T12:00:00";
}

function setDate(date: Date, ref: string) {
  if (!date) return;

  event.value[ref] = formatDate(date);

  if (ref === "publish_at") {
    publish_at_datepicker.value.closeMenu();
  }

  if (ref === "register_by") {
    register_by_datepicker.value.closeMenu();
  }
}

function setScheduleDate(i: number, date: Date) {
  if (!date) return;

  dates.value[i].event_date = formatDate(date);

  const futureTimezone = getFutureTimezone(dates.value[i].event_date, timezone.value);

  dates.value[i].timezone = futureTimezone.timezone;
  dates.value[i].short_timezone = futureTimezone.short_timezone;

  datepicker.value[i].closeMenu();
}

function setEventTags(e: number[]) {
  selectedTags.value = e;
}

function setEventTemplate(e: any) {
  const template = templates.value.find(temp => temp.id == e.target.value)!;

  selectedTemplate.value = template;
  event.value.template_id = template.id;

  selectedTemplatePricing.value = selectedTemplate.value.countries.find(country => country.country === user.value.country);

  if (!userIsAdmin.value) {
    event.value.trainer_pricing = selectedTemplatePricing.value.pricing / 100;
    event.value.trainer_currency = selectedTemplatePricing.value.currency;
    event.value.trainer_tax_status = selectedTemplatePricing.value.vat ? "inc" : "excl";
  }
}

function addEventDate() {
  dates.value.push({
    event_date: "",
    start_time: "",
    end_time: "",
    created_at: "",
    updated_at: "",
    timezone: timezone.value,
    short_timezone: short_timezone.value,
    timezone_offset: timezone_offset.value,
  });
}

function removeEventDate(index: number) {
  if (index === 0 && event.value.dates!.length < 2) {
    return (dates.value[0] = {
      event_date: "",
      start_time: "",
      end_time: "",
      created_at: "",
      updated_at: "",
      timezone: timezone.value,
      short_timezone: short_timezone.value,
      timezone_offset: timezone_offset.value,
    });
  }

  event.value.dates?.splice(index, 1);
}

function setAvailableCountries(stringCountries: string[]) {
  countries.value = stringCountries;
  isAvailableCountriesModalOpen.value = false;
}

async function saveEvent(e: any) {
  if (isSaving.value || isReviewSaving.value) {
    return;
  }
  event.value.status = e.submitter!.id;

  if (event.value.status !== "in review") {
    isSaving.value = true;
  } else {
    isReviewSaving.value = true;
    event.value.status = "in review";
  }

  try {
    const response = await api.events.updateEvent(String(event.value.id), {
      event: event.value,
      dates: dates.value.sort((a, b) => b - a),
      countries: countries.value,
      tags: selectedTags.value,
      presenters: presenters.value,
    });

    return router.push({ name: "Training_Event", params: { id: response.data.event.id } });
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", $t("error-updating-event"));
    isSaving.value = false;
  }
}

async function canDeleteEvent() {
  try {
    const response = await api.events.canDeleteEvent(String(event.value.id));
    return response.data.canDelete;
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", $t("error-checking-event-deletion"));
    return false;
  }
}

async function deleteEvent() {
  if (isSaving.value) {
    return;
  }

  isSaving.value = true;

  try {
    await api.events.deleteEvent(String(event.value.id));
    globalStore.toast("SUCCESS", $t("training-event-deleted"));
    return router.push({ name: "Training_Events" });
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", $t("error-deleting-event"));
    isSaving.value = false;
  }
}

async function archiveEvent() {
  if (isSaving.value) {
    return;
  }

  isSaving.value = true;

  try {
    await api.events.archiveEvent(String(event.value.id));
    globalStore.toast("SUCCESS", $t("training-event-archived"));
    //reload page to show unarchive button
    window.location.reload();
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", $t("error-archiving-event"));
    isSaving.value = false;
  }
}

async function unarchiveEvent() {
  if (isSaving.value) {
    return;
  }

  isSaving.value = true;

  try {
    await api.events.unarchiveEvent(String(event.value.id));
    globalStore.toast("SUCCESS", $t("training-event-archived"));
    //reload page to show archive button
    window.location.reload();
  } catch (e) {
    console.log("ERROR", e);
    globalStore.toast("ERROR", $t("error-archiving-event"));
    isSaving.value = false;
  }
}

const checkCurrency = (kevent: KeyboardEvent) => {
  const allowedKeys = ["Delete", "Backspace", ".", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "ArrowLeft", "ArrowRight"];
  if (!allowedKeys.includes(kevent.key)) {
    console.log("prevent");
    kevent.preventDefault();
  }

  // restrict to 2 decimal places
  if (event.value.trainer_pricing && event.value.trainer_pricing.toString().indexOf(".") > -1 && event.value.trainer_pricing.toString().split(".")[1].length > 1) {
    const allowedKeysDelete = ["Delete", "Backspace", "ArrowLeft", "ArrowRight"];
    if (!allowedKeysDelete.includes(kevent.key)) {
      console.log("prevent 2");
      kevent.preventDefault();
    }
  }
};

onMounted(async () => {
  try {
    isLoading.value = true;
    languages.value = (await api.misc.listLanguages()).languages;
    templates.value = (await api.templates.listTemplates("all")).data.templates;
    event.value = (await api.events.getEvent(String(route.params.id))).data.event;
    users.value = (
      await api.users.listUsers({
        page: "all",
        roles: ["l4a-trainer", "trainer-organisation", "admin", "courses-admin"],
      })
    ).data.users;

    selectedTemplate.value = event.value.template;
    dates.value = event.value.dates!.map(d => ({ ...d, event_date: utcToLocalNoon(d.event_date) }));

    if (event.value.publish_at) event.value.publish_at = utcToLocalNoon(event.value.publish_at);
    if (event.value.register_by) event.value.register_by = utcToLocalNoon(event.value.register_by);

    presenters.value = event.value.presenters.map(i => {
      return i.id;
    });

    countries.value =
      event.value.countries.length > 0
        ? event.value.countries.map(i => {
            return i.name;
          })
        : [];

    selectedTemplatePricing.value = selectedTemplate.value.countries.find(country => country.country === user.value.country);

    if (!userIsAdmin.value && event.value.trainer_pricing === 0) {
      event.value.trainer_pricing = selectedTemplatePricing.value.pricing / 100;
      event.value.trainer_currency = selectedTemplatePricing.value.currency.toUpperCase();
      event.value.trainer_tax_status = selectedTemplatePricing.value.vat ? "inc" : "excl";
    }

    if (event.value.trainer_pricing && event.value.trainer_pricing > 0) {
      event.value.trainer_pricing = event.value.trainer_pricing / 100;
    }

    // if user has role admin or courses-admin, check if they can delete the event
    if (userIsAdmin.value) {
      canDelete.value = await canDeleteEvent();
    }

    isLoading.value = false;
  } catch (error) {
    console.log(error);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (selectedTemplate.value.id)
      ? (_openBlock(), _createBlock(AvailableCountriesModal, {
          key: 0,
          isOpen: isAvailableCountriesModalOpen.value,
          template: event.value.template,
          countries: countries.value,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (isAvailableCountriesModalOpen.value = false)),
          onSelect: setAvailableCountries
        }, null, 8, ["isOpen", "template", "countries"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _unref($t)('edit-training-event')
      }, null, 8, ["title"])
    ]),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("form", {
          key: 1,
          class: "mt-8",
          onSubmit: _withModifiers(saveEvent, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(_unref($t)("you-are-editing-a-event-status-event-any-changes-will-effect-this-event", [event.value.status])), 1)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref($t)("event-summary")), 1),
            _createVNode(ListRowItem, {
              title: _unref($t)('course-template')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _withDirectives(_createElementVNode("select", {
                    id: "subscription",
                    class: "capitalize text-black border rounded w-full focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((event.value.template_id) = $event)),
                    onChange: setEventTemplate
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templates.value, (template) => {
                      return (_openBlock(), _createElementBlock("option", {
                        class: "capitalize",
                        value: template.id,
                        key: template.id
                      }, _toDisplayString(template.name), 9, _hoisted_5))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, event.value.template_id]
                  ])
                ])
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(ListRowItem, {
              title: _unref($t)('course-level'),
              class: "bg-play-gray"
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(selectedTemplate.value.level), 1)
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(ListRowItem, {
              title: _unref($t)('course-type'),
              class: "bg-play-gray"
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(deserializeSlug)(selectedTemplate.value.type)), 1)
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(ListRowItem, {
              title: _unref($t)('delivery-method'),
              class: "bg-play-gray"
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(deserializeSlug)(selectedTemplate.value.delivery)), 1)
              ]),
              _: 1
            }, 8, ["title"]),
            (event.value.template.delivery === 'live-webinar' || selectedTemplate.value.delivery === 'in-person')
              ? (_openBlock(), _createBlock(ListRowItem, {
                  key: 0,
                  title: _unref($t)('host-country')
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("select", {
                      id: "subscription",
                      class: "capitalize text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((event.value.host_country) = $event)),
                      required: ""
                    }, [
                      _createElementVNode("option", _hoisted_8, _toDisplayString(_unref($t)("please-select")), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTemplate.value.countries, (country) => {
                        return (_openBlock(), _createElementBlock("option", {
                          class: "capitalize",
                          value: country.country,
                          key: country.country
                        }, _toDisplayString(country.country), 9, _hoisted_9))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, event.value.host_country]
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true),
            _createVNode(ListRowItem, {
              title: _unref($t)('available-countries')
            }, {
              default: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countries.value, (country) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "capitalize",
                      key: country
                    }, _toDisplayString(country), 1))
                  }), 128))
                ]),
                _createVNode(DefaultButton, {
                  type: "primary",
                  class: "mt-4",
                  onAction: _cache[3] || (_cache[3] = ($event: any) => (isAvailableCountriesModalOpen.value = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("select-available-countries")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["title"]),
            (!_unref(isAsyncEvent))
              ? (_openBlock(), _createBlock(ListRowItem, {
                  key: 1,
                  title: _unref($t)('date-and-time'),
                  flex: false
                }, {
                  default: _withCtx(() => [
                    (selectedTemplate.value.delivery === 'webinar')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_unref($t)("optional")), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("table", _hoisted_11, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", _hoisted_12, [
                          _createElementVNode("th", _hoisted_13, _toDisplayString(_unref($t)("date")), 1),
                          _createElementVNode("th", _hoisted_14, _toDisplayString(_unref($t)("start-time")), 1),
                          _createElementVNode("th", _hoisted_15, _toDisplayString(_unref($t)("end-time")), 1),
                          _createElementVNode("th", _hoisted_16, _toDisplayString(_unref($t)("timezone")), 1),
                          _hoisted_17
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dates.value, (date, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: "border-b border-gray-400 divide-x-2 divide-gray-400 bg-play-gray",
                            key: index
                          }, [
                            _createElementVNode("td", _hoisted_18, [
                              _createVNode(_component_DatePicker, {
                                ref_for: true,
                                ref_key: "datepicker",
                                ref: datepicker,
                                modelValue: date.event_date,
                                "onUpdate:modelValue": ($event: any) => ((date.event_date) = $event),
                                onInternalModelChange: e => setScheduleDate(index, e),
                                required: syncEventDelivery.includes(selectedTemplate.value.delivery),
                                format: "dd/MMM/yyyy",
                                "enable-time-picker": false,
                                "min-date": new Date(),
                                onCleared: ($event: any) => (removeEventDate(index))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onInternalModelChange", "required", "min-date", "onCleared"])
                            ]),
                            _createElementVNode("td", _hoisted_19, [
                              _createVNode(_component_DatePicker, {
                                required: syncEventDelivery.includes(selectedTemplate.value.delivery),
                                "time-picker": "",
                                modelValue: date.start_time,
                                "onUpdate:modelValue": ($event: any) => ((date.start_time) = $event),
                                "model-type": "HH:mm"
                              }, null, 8, ["required", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("td", _hoisted_20, [
                              _createVNode(_component_DatePicker, {
                                required: syncEventDelivery.includes(selectedTemplate.value.delivery),
                                "time-picker": "",
                                modelValue: date.end_time,
                                "onUpdate:modelValue": ($event: any) => ((date.end_time) = $event),
                                "model-type": "HH:mm"
                              }, null, 8, ["required", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("td", _hoisted_21, [
                              _createElementVNode("p", null, _toDisplayString(date.short_timezone), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dates.value, (date, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "flex flex-wrap border-b-2 border-gray-300 bg-play-gray",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("label", _hoisted_24, _toDisplayString(_unref($t)("date")), 1),
                            _createVNode(_component_DatePicker, {
                              ref_for: true,
                              ref_key: "datepicker",
                              ref: datepicker,
                              modelValue: date.event_date,
                              "onUpdate:modelValue": ($event: any) => ((date.event_date) = $event),
                              onInternalModelChange: e => setScheduleDate(index, e),
                              "enable-time-picker": false,
                              format: "dd/MMM/yyyy",
                              class: "mt-1",
                              "min-date": new Date(),
                              onCleared: ($event: any) => (removeEventDate(index))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onInternalModelChange", "min-date", "onCleared"])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("label", _hoisted_26, _toDisplayString(_unref($t)("start-time")), 1),
                            _createVNode(_component_DatePicker, {
                              "time-picker": "",
                              modelValue: date.start_time,
                              "onUpdate:modelValue": ($event: any) => ((date.start_time) = $event),
                              class: "mt-1",
                              "model-type": "HH:mm"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("label", _hoisted_28, _toDisplayString(_unref($t)("end-time")), 1),
                            _createVNode(_component_DatePicker, {
                              "time-picker": "",
                              modelValue: date.end_time,
                              "onUpdate:modelValue": ($event: any) => ((date.end_time) = $event),
                              class: "mt-1",
                              "model-type": "HH:mm"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("label", _hoisted_30, _toDisplayString(_unref($t)("timezone")), 1),
                            _createElementVNode("p", null, _toDisplayString(date.short_timezone), 1)
                          ]),
                          _hoisted_31
                        ]))
                      }), 128))
                    ]),
                    (event.value.dates!.length > 0)
                      ? (_openBlock(), _createBlock(DefaultButton, {
                          key: 1,
                          type: "primary",
                          class: "mt-4",
                          onAction: addEventDate
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref($t)("add-another-date")), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true),
            _createVNode(ListRowItem, {
              title: _unref($t)('language')
            }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("select", {
                  id: "subscription",
                  class: "capitalize text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((event.value.language) = $event)),
                  required: ""
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(languages.value, (language) => {
                    return (_openBlock(), _createElementBlock("option", {
                      class: "capitalize",
                      value: language,
                      key: language
                    }, _toDisplayString(_unref($t)(language)), 9, _hoisted_32))
                  }), 128))
                ], 512), [
                  [_vModelSelect, event.value.language]
                ])
              ]),
              _: 1
            }, 8, ["title"]),
            (selectedTemplate.value.delivery !== 'in-person')
              ? (_openBlock(), _createBlock(ListRowItem, {
                  key: 2,
                  title: _unref($t)('selectedtemplate-type-e-learning-e-learning-online-meeting-link', [selectedTemplate.value.type === `e-learning` ? `E-learning` : `Online meeting`])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "location",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((event.value.meeting_link) = $event)),
                        class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded-r",
                        required: ""
                      }, null, 512), [
                        [_vModelText, event.value.meeting_link]
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true),
            (selectedTemplate.value.delivery === 'in-person')
              ? (_openBlock(), _createBlock(ListRowItem, {
                  key: 3,
                  title: _unref($t)('location')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_35, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "address_line_one",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((event.value.address_line_one) = $event)),
                        placeholder: _unref($t)('address-line-1'),
                        class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                        required: ""
                      }, null, 8, _hoisted_36), [
                        [_vModelText, event.value.address_line_one]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "address_line_two",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((event.value.address_line_two) = $event)),
                        placeholder: _unref($t)('address-line-2'),
                        class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded"
                      }, null, 8, _hoisted_37), [
                        [_vModelText, event.value.address_line_two]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "city",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((event.value.city) = $event)),
                        placeholder: _unref($t)('city'),
                        class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                        required: ""
                      }, null, 8, _hoisted_38), [
                        [_vModelText, event.value.city]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "postcode",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((event.value.postcode) = $event)),
                        placeholder: _unref($t)('postcode'),
                        class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                        required: ""
                      }, null, 8, _hoisted_39), [
                        [_vModelText, event.value.postcode]
                      ]),
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("select", {
                          id: "subscription",
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((event.value.country) = $event)),
                          class: "capitalize text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600"
                        }, [
                          _createElementVNode("option", _hoisted_40, _toDisplayString(_unref($t)("please-select-a-country")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countries.value, (country) => {
                            return (_openBlock(), _createElementBlock("option", {
                              class: "capitalize",
                              value: country,
                              key: country
                            }, _toDisplayString(country), 9, _hoisted_41))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, event.value.country]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "google_maps",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((event.value.maps_link) = $event)),
                          placeholder: _unref($t)('google-maps-optional'),
                          class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded"
                        }, null, 8, _hoisted_43), [
                          [_vModelText, event.value.maps_link]
                        ]),
                        _createElementVNode("span", _hoisted_44, [
                          _createTextVNode(_toDisplayString(_unref($t)("please-add-a-direct-link-to-help-the-user-find-the-venue-e-g")) + " ", 1),
                          _hoisted_45
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true),
            _createVNode(ListRowItem, {
              title: _unref($t)('organisation'),
              class: "bg-play-gray"
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(event.value.organisation.name), 1)
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(RoleGuard, { roles: ['admin', 'courses-admin', 'trainer-organisation'] }, {
              default: _withCtx(() => [
                _createVNode(ListRowItem, {
                  title: _unref($t)('event-owner')
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("select", {
                      id: "subscription",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((event.value.trainer_id) = $event)),
                      class: "text-black border w-full rounded focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 pr-8 h-10 border-gray-600"
                    }, [
                      _createElementVNode("option", {
                        value: _unref(user).id
                      }, _toDisplayString(_unref(user).first_name) + " " + _toDisplayString(_unref(user).last_name), 9, _hoisted_46),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: user.id,
                          key: user.id
                        }, _toDisplayString(user.first_name) + " " + _toDisplayString(user.last_name), 9, _hoisted_47))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, event.value.trainer_id]
                    ])
                  ]),
                  _: 1
                }, 8, ["title"])
              ]),
              _: 1
            }),
            (selectedTemplate.value.delivery !== 'e-learning')
              ? (_openBlock(), _createBlock(ListRowItem, {
                  key: 4,
                  title: _unref($t)('presenters'),
                  centerLabel: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(AddPresentersInput, {
                      presenters: presenters.value,
                      users: users.value,
                      onSelect: _cache[13] || (_cache[13] = $event => presenters.value.push($event)),
                      onRemove: _cache[14] || (_cache[14] = $event => presenters.value.splice($event, 1))
                    }, null, 8, ["presenters", "users"])
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true),
            _createVNode(ListRowItem, {
              title: _unref($t)('price')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_48, [
                  _createVNode(RoleGuard, { roles: ['admin', 'courses-admin'] }, {
                    default: _withCtx(() => [
                      (event.value.is_play_event)
                        ? (_openBlock(), _createBlock(PriceDisplay, {
                            key: 0,
                            locale: "en-GB",
                            price: selectedTemplatePricing.value.pricing,
                            currency: selectedTemplatePricing.value.currency,
                            vat: selectedTemplatePricing.value.vat
                          }, null, 8, ["price", "currency", "vat"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                            _createVNode(PriceDisplay, {
                              locale: "en-GB",
                              price: event.value.trainer_pricing! * 100,
                              currency: event.value.trainer_currency!,
                              vat: event.value.trainer_tax_status === 'inc'
                            }, null, 8, ["price", "currency", "vat"]),
                            _hoisted_50
                          ]))
                    ]),
                    _: 1
                  }),
                  _createVNode(RoleGuard, { roles: ['l4a-trainer', 'trainer-organisation'] }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_52, _toDisplayString(_unref($t)("price")), 1),
                          _withDirectives(_createElementVNode("input", {
                            onKeydown: checkCurrency,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((event.value.trainer_pricing) = $event)),
                            currency: event.value.trainer_currency,
                            type: "text",
                            class: "capitalize text-black border w-full focus:outline-none rounded-l focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600",
                            inputmode: "decimal"
                          }, null, 40, _hoisted_53), [
                            [_vModelText, event.value.trainer_pricing]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_54, _toDisplayString(_unref($t)("currency")), 1),
                          _withDirectives(_createElementVNode("select", {
                            id: "subscription",
                            class: "text-black border rounded-r w-32 focus:outline-none focus:shadow-outline-primary font-normal transition duration-50 ease-in px-3 py-1.5 h-10 border-gray-600 uppercase",
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((event.value.trainer_currency) = $event))
                          }, [
                            _createElementVNode("option", _hoisted_55, _toDisplayString(_unref($t)("please-select")), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTemplate.value.countries.map(country => {
                      return country.currency;
                    }), (currency) => {
                              return (_openBlock(), _createElementBlock("option", {
                                class: "uppercase",
                                value: currency.toUpperCase(),
                                key: currency
                              }, _toDisplayString(currency), 9, _hoisted_56))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, event.value.trainer_currency]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _createElementVNode("label", _hoisted_58, _toDisplayString(_unref($t)("includes-tax")), 1),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              name: "vat",
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((event.value.trainer_tax_status) = $event)),
                              value: "inc",
                              class: "rounded-full hover:cursor-pointer",
                              required: ""
                            }, null, 512), [
                              [_vModelRadio, event.value.trainer_tax_status]
                            ]),
                            _createElementVNode("label", _hoisted_61, _toDisplayString(_unref($t)("yes")), 1)
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              name: "vat",
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((event.value.trainer_tax_status) = $event)),
                              value: "excl",
                              class: "rounded-full hover:cursor-pointer",
                              required: ""
                            }, null, 512), [
                              [_vModelRadio, event.value.trainer_tax_status]
                            ]),
                            _createElementVNode("label", _hoisted_63, _toDisplayString(_unref($t)("no")), 1)
                          ]),
                          _createElementVNode("div", _hoisted_64, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              name: "vat",
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((event.value.trainer_tax_status) = $event)),
                              value: "none",
                              class: "rounded-full hover:cursor-pointer",
                              required: ""
                            }, null, 512), [
                              [_vModelRadio, event.value.trainer_tax_status]
                            ]),
                            _createElementVNode("label", _hoisted_65, _toDisplayString(_unref($t)("tax-free")), 1)
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(RoleGuard, { roles: ['l4a-trainer', 'admin', 'courses-admin', 'trainer-organisation'] }, {
              default: _withCtx(() => [
                (event.value.is_trainer_event || event.value.is_trainer_org_event)
                  ? (_openBlock(), _createBlock(ListRowItem, {
                      key: 0,
                      title: _unref($t)('payment-link')
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_66, [
                          _hoisted_67,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            id: "payment",
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((event.value.payment_link) = $event)),
                            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                            required: ""
                          }, null, 512), [
                            [_vModelText, event.value.payment_link]
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["title"]))
                  : _createCommentVNode("", true),
                (event.value.is_trainer_event || event.value.is_trainer_org_event)
                  ? (_openBlock(), _createBlock(ListRowItem, {
                      key: 1,
                      title: _unref($t)('payment-gateway')
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "payment",
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((event.value.payment_gateway) = $event)),
                          class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded",
                          placeholder: _unref($t)('i-e-paypal'),
                          required: ""
                        }, null, 8, _hoisted_68), [
                          [_vModelText, event.value.payment_gateway]
                        ])
                      ]),
                      _: 1
                    }, 8, ["title"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (selectedTemplate.value.delivery !== 'e-learning')
              ? (_openBlock(), _createBlock(ListRowItem, {
                  key: 5,
                  title: _unref($t)('minimum-attendees')
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      min: "0",
                      step: "1",
                      id: "min_attendees",
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((event.value.min_attendees) = $event)),
                      class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded"
                    }, null, 512), [
                      [_vModelText, event.value.min_attendees]
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true),
            (selectedTemplate.value.delivery !== 'e-learning')
              ? (_openBlock(), _createBlock(ListRowItem, {
                  key: 6,
                  title: _unref($t)('maximum-attendees')
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      min: "0",
                      step: "1",
                      id: "max_attendees",
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((event.value.max_attendees) = $event)),
                      class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded"
                    }, null, 512), [
                      [_vModelText, event.value.max_attendees]
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true),
            _createVNode(RoleGuard, { roles: ['l4a-trainer', 'admin', 'courses-admin', 'trainer-organisation'] }, {
              default: _withCtx(() => [
                _createVNode(ListRowItem, {
                  title: _unref($t)('go-live')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DatePicker, {
                      ref_key: "publish_at_datepicker",
                      ref: publish_at_datepicker,
                      onInternalModelChange: _cache[24] || (_cache[24] = e => setDate(e, 'publish_at')),
                      modelValue: event.value.publish_at,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((event.value.publish_at) = $event)),
                      required: "",
                      format: "dd/MMM/yyyy",
                      "min-date": new Date(),
                      "max-date": !_unref(isAsyncEvent) ? new Date(dates.value[0].event_date) : null,
                      "enable-time-picker": false
                    }, null, 8, ["modelValue", "min-date", "max-date"])
                  ]),
                  _: 1
                }, 8, ["title"])
              ]),
              _: 1
            }),
            (!asyncEventDelivery.includes(selectedTemplate.value.delivery))
              ? (_openBlock(), _createBlock(ListRowItem, {
                  key: 7,
                  title: _unref($t)('registration-cut-off-date')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DatePicker, {
                      ref_key: "register_by_datepicker",
                      ref: register_by_datepicker,
                      onInternalModelChange: _cache[26] || (_cache[26] = e => setDate(e, 'register_by')),
                      modelValue: event.value.register_by,
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((event.value.register_by) = $event)),
                      format: "dd/MMM/yyyy",
                      "min-date": new Date(event.value.publish_at),
                      "max-date": !_unref(isAsyncEvent) ? new Date(dates.value[0].event_date) : null,
                      "enable-time-picker": false
                    }, null, 8, ["modelValue", "min-date", "max-date"])
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_69, [
              _createVNode(TagSelector, {
                onChange: setEventTags,
                tags: event.value.tags,
                type: "event"
              }, null, 8, ["tags"])
            ])
          ]),
          _createElementVNode("div", _hoisted_70, [
            _createVNode(DefaultButton, {
              type: "primary",
              "is-form-submit": true,
              loading: isSaving.value,
              disabled: isSaving.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref($t)("save-training-event")), 1)
              ]),
              _: 1
            }, 8, ["loading", "disabled"]),
            (event.value.status === 'draft')
              ? (_openBlock(), _createBlock(DefaultButton, {
                  key: 0,
                  id: "in review",
                  "is-form-submit": true,
                  type: "primary",
                  loading: isReviewSaving.value,
                  disabled: isReviewSaving.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("submit-training-event-for-review")), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"]))
              : _createCommentVNode("", true),
            (!event.value.archived)
              ? (_openBlock(), _createBlock(RoleGuard, {
                  key: 1,
                  roles: ['admin', 'courses-admin']
                }, {
                  default: _withCtx(() => [
                    _createVNode(DefaultButton, {
                      type: "danger",
                      onAction: archiveEvent,
                      loading: isSaving.value,
                      disabled: isSaving.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($t)("archive-training-event")), 1)
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (event.value.archived)
              ? (_openBlock(), _createBlock(RoleGuard, {
                  key: 2,
                  roles: ['admin', 'courses-admin']
                }, {
                  default: _withCtx(() => [
                    _createVNode(DefaultButton, {
                      type: "danger",
                      onAction: unarchiveEvent,
                      loading: isSaving.value,
                      disabled: isSaving.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($t)("unarchive-training-event")), 1)
                      ]),
                      _: 1
                    }, 8, ["loading", "disabled"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(RoleGuard, { roles: ['admin', 'courses-admin'] }, {
              default: _withCtx(() => [
                _createVNode(DefaultButton, {
                  type: "danger",
                  class: _normalizeClass([!canDelete.value ? 'cursor-not-allowed !border-gray-600 !bg-gray-600 !hover:bg-gray-600 !hover:border-gray-600' : '']),
                  onAction: _cache[28] || (_cache[28] = ($event: any) => (isDeleteConfirmationOpen.value = true)),
                  loading: isSaving.value,
                  disabled: !canDelete.value || isSaving.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("delete-training-event")), 1)
                  ]),
                  _: 1
                }, 8, ["class", "loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _createVNode(ConfirmationModal, {
            buttonText: "Delete Event",
            class: "danger",
            isOpen: isDeleteConfirmationOpen.value,
            onDelete: deleteEvent,
            onClose: _cache[29] || (_cache[29] = ($event: any) => (isDeleteConfirmationOpen.value = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(_unref($t)("delete-event-confirmation")), 1)
            ]),
            _: 1
          }, 8, ["isOpen"])
        ], 40, _hoisted_1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})